import React from "react";
import { CellContext } from "@tanstack/react-table";

import HighlightText from "@adsk/alloy-react-highlight-text";
import Tooltip, { OverflowTooltip } from "@adsk/alloy-react-tooltip";

import { EntityWithCategoryAndStatus } from "../../../models";

const BaseCell = <T,>({
  getValue,
  searchExpression,
}: CellContext<EntityWithCategoryAndStatus<T>, string> & {
  searchExpression?: string;
}) => {
  return (
    <OverflowTooltip variant={Tooltip.VARIANTS.DARK}>
      <HighlightText matched={searchExpression} text={getValue()} />
    </OverflowTooltip>
  );
};

export default BaseCell;
